/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentEntityHistoricalData} from '../api'

 export const useQueryGetInvestmentEntityHistoricalData = createReactQueryHook('getInvestmentEntityHistoricalData', getInvestmentEntityHistoricalData)
